import { languageEnglish } from "../i18n";

interface TranslatableStory {
  translated_slugs?: { lang: string; name?: string | null }[] | null;
}

/**
 * Checks if a story is translated into English.
 *
 * @param story - The story object to check for translation.
 * @returns {boolean} - Returns true if the story is translated, false otherwise.
 */
export const isStoryTranslated = (story: TranslatableStory): boolean => {
  const translatedData = story.translated_slugs?.find(
    (obj) => obj.lang === languageEnglish
  );

  return (
    typeof translatedData?.name === "string" && translatedData.name.length > 0
  );
};
